import React, { ChangeEvent, ReactNode } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { InputTextarea } from 'primereact/inputtextarea';
import { Labelled, LabelledProps } from './Labelled';

interface LabelledInputTextProps extends LabelledProps {
  value: string;
  onChange: (value: string) => void;
  pattern?: string;
  autoFocus?: boolean;
  className?: string;
  autoResize?: boolean;
  rows?: number;
  placeholder?: string;
  isNew?: boolean;
}

export const LabelledInputTextarea = (props: LabelledInputTextProps): ReactNode => {
  const intl: IntlShape = useIntl();
  const disabled: boolean = (props.permissions ? !props.permissions.canWrite : false) || props.disabled;
  return (
    <Labelled {...props}>
      <InputTextarea
        id={props.id}
        value={props.value || ""}
        required={props.permissions?.required || props.required}
        invalid={props.validation && !props.validation?.valid}
        disabled={disabled}
        onChange={(e: ChangeEvent<HTMLTextAreaElement>): void => props.onChange(e.target.value)}
        tooltip={(props.validation && !props.validation?.valid && props.validation.reason) ? props.validation.reason.split(';').map((reason: string): string => intl.formatMessage({id: reason})).join('; ') : undefined}
        tooltipOptions={{position: 'bottom'}}
        autoFocus={props.autoFocus}
        className={props.className + `${props.isNew && props.validation && props.validation?.valid ? ' border-primary-500 border-3' : ''}`}
        autoResize={props.autoResize}
        rows={props.rows}
        placeholder={props.placeholder}
      />
    </Labelled>
  );
};
